// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__Z4BCb","element":"styles_element__mV_yx","red":"styles_red__uLrk4","white":"styles_white__HgI7z","black":"styles_black__R34QF"};